import {handlebar}            from "@Common/libs/handlebars/handlebars";
import {handlebarsDateformat} from "@Common/libs/handlebars/handlebars-dateformat";
import {numeralHelper}        from "@Common/libs/handlebars/numeral-helper";
import {he}                   from "@Common/libs/he/he";
import {isDevXd}              from "@Common/ui-components/debug/is-dev";

const Handlebars = handlebar.create();
numeralHelper.registerHelpers(Handlebars);

Handlebars.registerHelper("dateFormat", handlebarsDateformat);

export function comparisonHelper (v1, operator, v2, options) {
    switch (operator) {
        case '==':
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '!==':
            return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
};

export function strWrap (split, preString, postString, options) {
    let multiLineText = options.fn(this);
    let lines = multiLineText.split(split);
    let res = '';
    
    for (const line of lines) {
        res = res + preString + line + postString;
    }
    return res;
}

export function strReplace(find, replace, options){
    const value = options.fn(this);
    return value ? value.split(find).join(replace) : '';
}

//Can not use a lambda function for this helper because transpiled js messes with "this" pointer.
export function deepBind (...params){
    try{
        let _this = this;
        //remove the name of the helper
        params.pop();

        params.forEach( (param, key) => {
            if(param.includes("{{")) {
                let res = Handlebars.compile(param, { noEscape: true });
                let result = he.decode(res(_this));
                isDevXd() ? console.log("----deepBind individual result---", result): null;
                params[key] = result;
            }
        });
        let bindingString = `{{${params.join('')}}}`;

        // let sum = '';
        // for (let input of inputs) sum += input;
        let res = Handlebars.compile(bindingString, { noEscape: true });
        let result = he.decode(res(_this));

        return result;
    }
    catch(e){
        isDevXd() ? console.log("deepBind couldn't bind the data: ", e) : null;

        return null
    }
}

export function trimStart (...params){
    try{
        let _this = this;
        //remove the name of the helper
        params.pop();
        let result = null;
        let flip = false;
        if( params[0] && params[1] )
        {
            if(params[2]){
                flip = true;
            }
            if(params[0].includes("{{")) {
                let res = Handlebars.compile(params[0], { noEscape: true });
                let result = he.decode(res(_this));
                isDevXd() ? console.log("----split param result---", result): null;
                params[0] = result;
            }
            if( params[0].indexOf(params[1])>=0 )
            {
                let index = 0;
                if( params[1] && !isNaN(params[1]) ){
                    index = parseInt(params[1], 10);
                }
                else{ 
                    if( flip ){
                        index = params[0].lastIndexOf(params[1])
                    }
                    else{
                        index = params[0].indexOf(params[1])
                    }
                }
                if( flip ){
                    result = params[0].substring(index+1);
                }
                else{
                    result = params[0].substring(0, index);
                }
            }
            else
            {
                if( params[1] && !isNaN(params[1]) ){
                    let index = parseInt(params[1], 10);
                    if( flip ){
                        result = params[0].substring(index+1);
                    }
                    else{
                        result = params[0].substring(0, index);
                    }
                }
                else{
                    result = params[0];
                }
            }
        }

        return result;
    }
    catch(e){
        isDevXd() ? console.log("split couldn't split the data: ", e) : null;

        return null
    }
}

export function xdDateFormat (...params){
    try{
        let _this = this;
        //remove the name of the helper
        params.pop();

        if( params.length>1 && params[0] )
        {
            let result = params[0];
            let dateValue = new Date(result);
            if(dateValue == "Invalid Date"){
                return '';
            }
            if(params.length>3 && params[2] && params[3]){
                if(params[2] == 'day'){
                    dateValue.setDate(dateValue.getDate() + parseInt(params[3], 10))
                }
                else if(params[2] == 'month'){
                    dateValue.setMonth(dateValue.getMonth() + parseInt(params[3], 10))
                }
                else if(params[2] == 'year'){
                    dateValue.setFullYear(dateValue.getFullYear() + parseInt(params[3], 10))
                }
            }
            let bindingString = "{{dateFormat '" + dateValue.toString() + "' '" + params[1] + "'}}";
            let dateFormat = Handlebars.compile(bindingString, { noEscape: true });
            let dateResult = he.decode(dateFormat(_this));
            if( dateResult === "Invalid date" )
            {
                dateResult = result;
            }
            isDevXd() ? console.log( "----xdDateFormat individual result---",  dateResult ): null;
            return dateResult;
        }
        isDevXd() ? console.log( "----xdDateFormat invalid parameters---",  params ): null;
        return null;
    }
    catch(e){
        isDevXd() ? console.log("xdDateFormat couldn't bind the data: ", e) : null;
        return null
    }
}

export function uppercase (input){
    try{
        let _this = this;
        //remove the name of the helper
        let result = '';
        if( input )
        {
            if(input.includes("{{")) {
                let res = Handlebars.compile(input, { noEscape: true });
                let result = he.decode(res(_this));
                isDevXd() ? console.log("----uppercase param result---", result): null;
                input = result;
            }
            result = input.toUpperCase();
        }
        return result;
    }
    catch(e){
        isDevXd() ? console.log("uppercase failed: ", e) : null;
        return null
    }
}

export function lowercase (input){
    try{
        let _this = this;
        //remove the name of the helper
        let result = '';
        if( input )
        {
            if(input.includes("{{")) {
                let res = Handlebars.compile(input, { noEscape: true });
                let result = he.decode(res(_this));
                isDevXd() ? console.log("----lowercase param result---", result): null;
                input = result;
            }
            result = input.toLowerCase();
        }
        return result;
    }
    catch(e){
        isDevXd() ? console.log("lowercase failed: ", e) : null;
        return null
    }
}

Handlebars.registerHelper('ifCond', comparisonHelper);
Handlebars.registerHelper('strWrap', strWrap);
Handlebars.registerHelper('strReplace', strReplace);
Handlebars.registerHelper('deepBind', deepBind);
Handlebars.registerHelper('trimStart', trimStart);
Handlebars.registerHelper('xdDateFormat', xdDateFormat);
Handlebars.registerHelper('uppercase', uppercase);
Handlebars.registerHelper('lowercase', lowercase);